import { ModuleWithProviders, NgModule } from '@angular/core';
import { JTUserIdleConfig } from './user-idle.config';

@NgModule({
  imports: []
})
export class JTUserIdleModule {
  static forRoot(config: JTUserIdleConfig): ModuleWithProviders<JTUserIdleModule> {
    return {
      ngModule: JTUserIdleModule,
      providers: [
        { provide: JTUserIdleConfig, useValue: config}
      ]
    };
  }
}
